module.exports = __webpack_public_path__ + "a8be3ea4d32e2b091a49965ffa9a6c57.svg";